module.exports = __webpack_public_path__ + "img/monthly_customer_registration_count.0338b0bf.svg";